import type { QueryClient } from '@tanstack/react-query'

/**
 * `/api/employees` answers with two shapes, so the roster is cached under two
 * keys: `['employees']` is the redacted directory every screen reads through
 * `listEmployees()`, `['team']` the admin view behind `listTeam()`. A roster
 * mutation invalidates both — otherwise the Team page and the assignee chips
 * disagree about who exists.
 */
export function refreshRoster(qc: QueryClient) {
  qc.invalidateQueries({ queryKey: ['employees'] })
  qc.invalidateQueries({ queryKey: ['team'] })
}
